import React, {
  useState, useContext, useEffect, SetStateAction, Dispatch,
} from 'react';
import styled from 'styled-components';
import { EditorView } from 'prosemirror-view';
import { AuthContext } from '../../../../App';
import Notes from '../../../../pages/meeting/notes';
import {
  MeetingSection, Page, Shortcut, TaskItems, TaskTab,
} from '../../../types/types';
import Tasks from '../../tasks';
import { ALL_PAGES } from '../../../../utils/enums';
import { toastInfo } from '../../../../utils/notifications';

const Container = styled.div`
  width: 460px;
  height: calc(100vh - 150px - 60px);
  overflow: hidden;
`;

interface Props {
  meetingId: string
  meetingTab: MeetingSection
  meetingTasks: TaskItems,
  setCreateTaskModalOpen: Dispatch<SetStateAction<boolean>>,
  taskTab: TaskTab,
  setTaskTab: Dispatch<SetStateAction<TaskTab>>,
}

const PreviousMeetingNotesView = ({
  meetingId,
  meetingTab,
  meetingTasks,
  setCreateTaskModalOpen,
  taskTab,
  setTaskTab,
}: Props) => {
  const authState = useContext(AuthContext);

  /* eslint-disable-next-line no-unused-vars */
  const [notesContent, setNotesContent] = useState<string>('');
  /* eslint-disable-next-line no-unused-vars */
  const [isTabContentSynchronized, setTabContentSynchronized] = useState<boolean>(true);
  const [proseMirrorEditorView, setProseMirrorEditorView] = useState<EditorView | null>(null);

  useEffect(() => {
    console.log(proseMirrorEditorView);
  }, [proseMirrorEditorView]);

  const handleShortcutTrigger = (shortcut: Shortcut) => {
    if (shortcut === 'navigateLeft') {
      // leftKeyNavigation(meetingTab, setMeetingTab);
      // TODO: Handle
    }
    if (shortcut === 'navigateRight') {
      // rightKeyNavigation(meetingTab, setMeetingTab);
      // TODO: Handle
    }
    if (shortcut === 'openCreateTask') {
      // setCreateTaskModalOpen(true);
      // TODO: Handle
    }
  };

  /**
   * Will not be called since in lower level component we
   * check if we are inside a previous meeting, which we are,
   * and if we are, we don't call this function
   */
  const handleSetPage = (page: Page) => {
    console.log('handle set page in NotesView', page);
    toastInfo("You can't go to the meeting from here", 'Sorry! 😅');
  };

  if (meetingTab === 'task') {
    return (
      <Tasks
        setPage={handleSetPage}
        taskTab={taskTab}
        setTaskTab={setTaskTab}
        taskItems={meetingTasks}
        setCreateTaskModalOpen={setCreateTaskModalOpen}
        height="calc(100vh - 150px - 60px)"
        taskPage="meeting"
      />
    );
  }

  return (
    <Container>
      <Notes
        noteType={meetingTab}
        userId={authState.userId}
        meetingId={meetingId}
        setProseMirrorEditorView={setProseMirrorEditorView}
        onShortcutTrigger={handleShortcutTrigger}
        isPreviousMeeting
        notesFor={ALL_PAGES.PREV_MEETING}
      />
    </Container>
  );
};

export default PreviousMeetingNotesView;
